import React from "react";
import { Typography } from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import AddIcon from "@mui/icons-material/Add";

/**
 * The folder-with-a-plus every add button in the tree carries, so "add a
 * project", "add a WBS" and "add a revision" read as the same action at
 * different levels.
 */
export const AddActionIcon = ({ color }) => (
  <>
    <FolderIcon fontSize="small" sx={{ color }} />
    <AddIcon fontSize="inherit" sx={{ color, ml: -0.5, mt: -1 }} />
  </>
);

/**
 * The wording beside that icon. Deliberately tiny and muted - it names the
 * action without competing with the tree's own rows or with the icon.
 */
export const AddActionLabel = ({ children, color = "text.disabled" }) => (
  <Typography
    component="span"
    sx={{
      ml: 0.25,
      fontSize: 9.5,
      fontWeight: 600,
      lineHeight: 1,
      letterSpacing: 0.2,
      whiteSpace: "nowrap",
      color,
    }}
  >
    {children}
  </Typography>
);
